import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import API_BASE_URL from '../config';

export const AdminAuthContext = createContext();

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    axios.get(`${API_BASE_URL}/admin/auth/session`).then(({ data }) => {
      setAdmin(data.admin);
      if (data.admin) localStorage.setItem('admin', data.admin);
      else localStorage.removeItem('admin');
    }).catch(() => { setAdmin(null); localStorage.removeItem('admin'); })
      .finally(() => setLoading(false));
  }, []);

  // Funzione per il login
  const login = async (username, password) => {
    try {
      await axios.post(`${API_BASE_URL}/admin/auth/login`, { username, password });
      setAdmin(username);
      localStorage.setItem('admin', username);
    } catch (error) {
      console.error('Login admin fallito:', error);
      throw error;
    }
  };

  // Funzione per la registrazione
  const register = async (username, password, secretKey) => {
    try {
      await axios.post(`${API_BASE_URL}/admin/auth/register`, { username, password, secretKey });
      alert('Registrazione admin riuscita!');
    } catch (error) {
      console.error('Registrazione admin fallita:', error);
      throw error;
    }
  };

  // Funzione per il logout
  const logout = async () => {
    await axios.post(`${API_BASE_URL}/admin/auth/logout`);
    setAdmin(null);
    localStorage.removeItem('admin');
  };

  return (
    <AdminAuthContext.Provider value={{ admin, loading, login, register, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
};
